import { styled } from '@mui/material/styles';
import { DatagridWithStickyActions } from 'shared/react-admin/Datagrids/DatagridWithStickyActions/DatagridWithStickyActions';
import { getColumnStyle } from 'utils';

export const DatagridStyled = styled(DatagridWithStickyActions)({
  '& .MuiTableCell-root': {
    verticalAlign: 'middle',
    padding: '8px 16px',
  },
  '& .MuiTableCell-head': {
    padding: '18px 16px',
  },
  '& .column-refId': getColumnStyle(115),
  '& .column-createdAt': getColumnStyle(133),
  '& .column-updatedAt': getColumnStyle(137),
});
